import React from "react";

export default function AppsShowcaseSchema() {
  const docnoApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "DocNo – Notes, Expenses & Docs",
    alternateName: ["DocNo", "DocNo Notes", "DocNo Expense Tracker"],
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Finance & Productivity",
    operatingSystem: "Android 8.0 and up",
    url: "https://almondsoftwares.in/apps#docno",
    installUrl: "https://play.google.com/store/apps/details?id=com.almondsoftwares.docno",
    downloadUrl: "https://play.google.com/store/apps/details?id=com.almondsoftwares.docno",
    description:
      "All-in-one offline Android productivity app combining smart markdown notes, daily expense and budget tracking, encrypted document vault with receipt scanner, and integrated financial calculator. 100% private local storage with zero cloud telemetry. Available for a one-time purchase of ₹10.",
    offers: {
      "@type": "Offer",
      price: "10",
      priceCurrency: "INR",
      priceValidUntil: "2030-12-31",
      availability: "https://schema.org/InStock"
    },
    softwareVersion: "1.0",
    fileSize: "18MB",
    contentRating: "Everyone",
    screenshot: [
      "https://almondsoftwares.in/docno-preview.jpg",
      "https://almondsoftwares.in/docno-expense.jpg"
    ],
    featureList: [
      "Smart markdown notes with checklists and tags",
      "Monthly expense budget tracker with category breakdown",
      "Offline biometric encrypted document vault",
      "Receipt scanner with multi-page PDF generation",
      "Integrated financial calculator with tape history",
      "100% offline local SQLite storage with zero tracking"
    ],
    author: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in",
      sameAs: [
        "https://play.google.com/store/apps/developer?id=ALMOND+SOFTWARES"
      ]
    },
    publisher: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in"
    }
  };

  const forgeApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Forge - Photo Editor & Graphic Studio",
    alternateName: ["Forge Photo Editor", "Forge Studio", "Forge"],
    applicationCategory: "PhotographyApplication",
    applicationSubCategory: "Graphic Design & Photo Retouching",
    operatingSystem: "Android 8.0 and up",
    url: "https://almondsoftwares.in/apps#forge",
    installUrl: "https://play.google.com/store/apps/details?id=com.almondsoftwares.forge",
    downloadUrl: "https://play.google.com/store/apps/details?id=com.almondsoftwares.forge",
    description:
      "Professional desktop-grade Android photo editor featuring a multi-layer engine, 24 blend modes, RGB tone curves, 3D LUT grading, on-device neural AI sky replacement, subject isolation, spot healing, and lossless RAW pipeline.",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock"
    },
    softwareVersion: "1.0",
    fileSize: "32MB",
    contentRating: "Everyone",
    screenshot: [
      "https://almondsoftwares.in/forge-preview.jpg",
      "https://almondsoftwares.in/forge-tools.jpg"
    ],
    featureList: [
      "Multi-layer system supporting raster, text, adjustment, and shape layers",
      "24 industry-standard blend modes (Screen, Multiply, Overlay)",
      "Interactive RGB and Luminance tone curves",
      "On-device neural AI sky replacement and subject isolation",
      "Frequency separation and spot healing retouching tools",
      "16-bit color engine with RAW image support (DNG, CR2, NEF)"
    ],
    author: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in",
      sameAs: [
        "https://play.google.com/store/apps/developer?id=ALMOND+SOFTWARES"
      ]
    },
    publisher: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in"
    }
  };

  const videoApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Almond Video Player",
    alternateName: ["Almond Player", "Almond Video", "AVP"],
    applicationCategory: "MultimediaApplication",
    applicationSubCategory: "Video Players & Editors",
    operatingSystem: "Android 8.0 and up",
    url: "https://almondsoftwares.in/apps#video",
    installUrl: "https://play.google.com/store/apps/details?id=com.a.almondvideoplayer&pcampaignid=web_share",
    downloadUrl: "https://play.google.com/store/apps/details?id=com.a.almondvideoplayer&pcampaignid=web_share",
    description:
      "Ad-free Android video player with hardware-accelerated 4K/8K playback, built-in browser with automatic video stream detection and downloading, HLS and DASH streaming, subtitle sync, and gesture controls.",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock"
    },
    softwareVersion: "1.0",
    fileSize: "24MB",
    contentRating: "Everyone",
    screenshot: [
      "https://almondsoftwares.in/avp1 (1).jpeg",
      "https://almondsoftwares.in/avp1 (2).jpeg"
    ],
    featureList: [
      "All video formats (MKV, MP4, AVI, MOV, FLV, WEBM, 3GP, TS)",
      "Built-in web browser with automatic video stream downloader",
      "HLS (M3U8) and MPEG-DASH network streaming",
      "Hardware-accelerated GPU decode engine with 60fps/120fps playback",
      "External subtitle support (SRT, VTT) with sub-second sync adjustment",
      "Intuitive brightness and volume swipe gesture controls"
    ],
    author: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in",
      sameAs: [
        "https://play.google.com/store/apps/developer?id=ALMOND+SOFTWARES"
      ]
    },
    publisher: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in"
    }
  };

  const musicApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Almond Music Player",
    alternateName: ["Almond Music", "AMP", "Almond Audio"],
    applicationCategory: "MultimediaApplication",
    applicationSubCategory: "Music & Audio",
    operatingSystem: "Android 8.0 and up",
    url: "https://almondsoftwares.in/apps#music",
    installUrl: "https://play.google.com/store/apps/details?id=com.a.almondmusicplayer&pcampaignid=web_share",
    downloadUrl: "https://play.google.com/store/apps/details?id=com.a.almondmusicplayer&pcampaignid=web_share",
    description:
      "Studio-grade offline Android music player with an industry-leading 64-band equalizer, 24-band parametric EQ, real-time 60fps spectrum analyzer, gapless playback, smart acoustic sound profiles, and privacy-first local DSP engine.",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock"
    },
    softwareVersion: "1.0",
    fileSize: "22MB",
    contentRating: "Everyone",
    screenshot: [
      "https://almondsoftwares.in/amp (1).jpeg",
      "https://almondsoftwares.in/amp (2).jpeg"
    ],
    featureList: [
      "64-band studio graphic equalizer with high precision Q-factor",
      "24-band parametric equalizer for surgical sound calibration",
      "Real-time 60fps FFT spectrum analyzer and LUFS loudness meter",
      "Smart acoustic profiles: Bass Boost, 3D Surround, Clear Voice",
      "Gapless playback with bit-perfect 24-bit/192kHz audio processing",
      "100% offline local library indexing with zero data tracking"
    ],
    author: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in",
      sameAs: [
        "https://play.google.com/store/apps/developer?id=ALMOND+SOFTWARES"
      ]
    },
    publisher: {
      "@type": "Organization",
      name: "Almond Software",
      url: "https://almondsoftwares.in"
    }
  };

  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Almond Software Flagship Android Mobile Applications",
    description:
      "Comprehensive suite of Android applications developed by Almond Software: DocNo (smart notes & budget tracker — ₹10), Forge (pro photo editor & graphic studio), Almond Video Player (4K ad-free player), and Almond Music Player (64-band EQ).",
    itemListElement: [
      { "@type": "ListItem", position: 1, item: docnoApp },
      { "@type": "ListItem", position: 2, item: forgeApp },
      { "@type": "ListItem", position: 3, item: videoApp },
      { "@type": "ListItem", position: 4, item: musicApp }
    ]
  };

  const breadcrumbs = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://almondsoftwares.in/"
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Android Apps",
        item: "https://almondsoftwares.in/apps"
      }
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is the price of DocNo and how does it compare to other apps?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "DocNo is available on Google Play for a single one-time payment of ₹10 with lifetime access (zero monthly subscriptions, zero ads). Forge Photo Editor, Almond Video Player, and Almond Music Player are free to download on Google Play."
        }
      },
      {
        "@type": "Question",
        name: "Is DocNo completely offline and secure for sensitive documents and financial expenses?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. DocNo operates completely offline using local biometric and AES-256 encryption. Your daily expense ledger, budgets, scanned receipts, and personal notes remain exclusively on your device and are never sent to external servers."
        }
      },
      {
        "@type": "Question",
        name: "Does Forge Photo Editor support multi-layer editing and 24 blend modes?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Forge brings desktop-grade editing to Android with full raster, text, shape, and adjustment layers, 24 blend modes (Multiply, Screen, Overlay, etc.), RGB curves, and on-device AI neural masking."
        }
      },
      {
        "@type": "Question",
        name: "Can Almond Video Player download web video streams and play 4K MKV files?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Almond Video Player features a built-in browser that auto-detects video streams on web pages for fast downloading, supports HLS/DASH network streams, and decodes 4K Ultra-HD MKV, MP4, and AVI files with zero ad interruptions."
        }
      },
      {
        "@type": "Question",
        name: "What makes Almond Music Player's 64-band equalizer unique?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Almond Music Player features an industry-leading 64-band graphic equalizer alongside a 24-band parametric EQ, a real-time 60fps FFT spectrum analyzer, and high-fidelity 24-bit/192kHz DSP audio processing running natively on Android."
        }
      },
      {
        "@type": "Question",
        name: "Where can I find the official Google Play store listings for Almond Software apps?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "All applications can be verified and installed directly from the official Almond Software Google Play Developer page at: https://play.google.com/store/apps/developer?id=ALMOND+SOFTWARES."
        }
      }
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbs) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}